import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { View, ScrollView } from 'react-native';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import { Tabs } from '../../../components/Tabs';
import { SelectableItem, SelectableList } from '../../../components/SelectableList';
import Toast from 'react-native-toast-message';
import { accessService } from '../../../services/central-api/access';
import MyPhoneInput from '../../../components/MyPhoneInput';
import MyAppText from '../../../components/MyAppText';
import { ClientError } from '../../../services/central-api/base-service';
import { centralAPI } from '../../../services/central-api';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import ProfilePicture from '../../../components/user/ProfilePicture';
import MyCpfInput from '../../../components/MyCpfInput';
import { useAuth } from '../../../context/Auth';
import UpdateActingBodyUnitModal from './UpdateActingBodyUnitModal';
import CustomButton from '../../../components/CustomButton';
import { NavigationProp, RouteProp, useFocusEffect, useIsFocused, useNavigation, useRoute } from '@react-navigation/native';
import RolesDropdown from '../../../components/Dropdowns/RolesDropdown';
import ActingBodiesUnitsDropdown from '../../../components/Dropdowns/ActingBodiesUnitsDropdown';
import ActingBodiesDropdown from '../../../components/access/ActingBodiesDropdown';
import TagsDropdown from '../../../components/access/TagsDropdown';
import { WindowInformation } from '../../../services/window-information';
import WarningModal from '../../../components/WarningModal';
import moment from 'moment';
import WorkScheduleDropdown from '../../../components/Dropdowns/WorkScheduleDropdown';

type ValuePiece = Date | null;

import { deacService } from '../../../services/central-api/deac';
import MapPolygonDropdown from '../../../components/MapPolygonDropdown';
import MyDropDownPicker from '../../../components/MyDropDownPicker';
import MyEmailInput from '../../../components/MyEmailInput';
import MyDateRangePicker from '../../../components/MyDateRangePicker';
import { useForm } from 'react-hook-form';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import Card from '../../../components/Card';
import { AccessParamList } from '../../../typings/Params';
import { permissionsValuesStructure } from '../PermissionLevels/PermissionLevelForm';
import FilterCheckBox from '../../../components/Filter/components/FilterCheckBox';
import Badge from '../../../components/Badge';
import UserHistoricList from './UserHistoricList';
import MyDatePicker from '../../../components/MyDatePicker';

interface UserFormFields {
    vacation: { from: ValuePiece; to: ValuePiece; };
    leave: { from: ValuePiece; to: ValuePiece; };
    visitorStartDate: ValuePiece;
    visitorEndDate: ValuePiece;
}

export default function UserForm() {
    const navigation = useNavigation<NavigationProp<AccessParamList>>();
    const route = useRoute<RouteProp<AccessParamList, 'UserForm'>>();
    const userId = route.params?.id;
    const { styles, theme } = useStyles(stylesheet);
    const windowInfo = WindowInformation();

    const { user: authenticatedUser } = useAuth();

    const [ownUser, setOwnUser] = useState<UserData>();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [registry, setRegistry] = useState('');
    const [phone, setPhone] = useState('');
    const [patent, setPatent] = useState('');
    const [warName, setWarName] = useState('');
    const [document, setDocument] = useState('');
    const [isDocumentInvalid, setIsDocumentInvalid] = useState(false);
    const [selectableGroups, setSelectableGroups] = useState<SelectableItem[]>([]);
    const [selectablePermissionLevels, setSelectablePermissionLevels] = useState<SelectableItem[]>([]);
    const [selectableSkills, setSelectableSkills] = useState<SelectableItem[]>([]);
    const [selectedGroups, setSelectedGroups] = useState<SelectableItem[]>([]);
    const [selectedPermissionLevels, setSelectedPermissionLevels] = useState<SelectableItem[]>([]);
    const [selectedSkills, setSelectedSkills] = useState<SelectableItem[]>([]);
    const [userGroupIds, setUserGroupIds] = useState<number[]>([]);
    const [userPermissionLevelIds, setUserPermissionLevelIds] = useState<number[]>([]);
    const [userSkillsIds, setUserSkillsIds] = useState<number[]>([]);
    const [actingBodyId, setActingBodyId] = useState<number>(0);
    const [roleId, setRoleId] = useState<number>(0);
    const [actingBodyUnitId, setActingBodyUnitId] = useState<number>(0);
    const [profilePicture, setProfilePicture] = useState<string>('');
    const [selectedTagsIds, setSelectedTagsIds] = useState<number[]>([]);

    const [selectedPolygon, setSelectedPolygon] = useState<number>(0);
    const [isPolygonPickerOpen, setIsPolygonPickerOpen] = useState(false);
    const [polygonType, setPolygonType] = useState<string | null>(null);
    const [selectedPolygons, setSelectedPolygons] = useState<MapPolygon[]>([]);
    const [userBlockedWorkplacesIds, setUserBlockedWorkplacesIds] = useState<number[]>([]);
    const [workplaces, setWorkplaces] = useState<Workplace[]>([]);
    const [selectableWorkplaces, setSelectableWorkplaces] = useState<SelectableItem[]>([]);
    const [selectedWorkplaces, setSelectedWorkplaces] = useState<SelectableItem[]>([]);

    const [updateUserModal, setUpdateUserModal] = useState<boolean>(false);
    const [updateUserModalDisplayed, setUpdateUserModalDisplayed] = useState<boolean>(false);
    const [tmpActingBodyUnitId, setTmpActingBodyUnitId] = useState<number>(0);
    const [deacApplicationsWarningModal, setDeacApplicationsWarningModal] = useState<boolean>(false);
    const [changeForWarningModal, setChangeForWarningModal] = useState<string[]>([]);
    const [originalRoleId, setOriginalRoleId] = useState<number>(0);

    const [workScheduleId, setWorkScheduleId] = useState<number>(0);
    const [originalWorkScheduleId, setOriginalWorkScheduleId] = useState<number>(0);
    const [isEmailInvalid, setIsEmailInvalid] = useState<boolean>(false);

    const [isBlocked, setIsBlocked] = useState<boolean>(false);
    const [isVisitor, setIsVisitor] = useState<boolean>(false);
    const [visitorStartZIndex, setVisitorStartZIndex] = useState<number>(10);
    const [visitorFinishZIndex, setVisitorFinishZIndex] = useState<number>(9);

    const [permissions, setPermissions] = useState<(PermissionLevelData & { permissions: { id: number; permission: string; }[]; })[]>();
    const [wasCreatedAsVisitor, setWasCreatedAsVisitor] = useState<boolean>(false);

    const defaultEmptyValues: UserFormFields = {
        vacation: { from: null, to: null },
        leave: { from: null, to: null },
        visitorStartDate: null,
        visitorEndDate: null,
    };

    const form = useForm<UserFormFields>({
        defaultValues: defaultEmptyValues,
        mode: 'onChange'
    });

    function cleanValues() {
        setOwnUser(undefined);
        setName('');
        setEmail('');
        setPassword('');
        setRegistry('');
        setPhone('');
        setPatent('');
        setWarName('');
        setDocument('');
        setIsDocumentInvalid(false);
        setSelectableGroups([]);
        setSelectablePermissionLevels([]);
        setSelectableSkills([]);
        setSelectedGroups([]);
        setSelectedPermissionLevels([]);
        setSelectedSkills([]);
        setUserGroupIds([]);
        setUserPermissionLevelIds([]);
        setUserSkillsIds([]);
        setActingBodyId(0);
        setRoleId(0);
        setActingBodyUnitId(0);
        setProfilePicture('');
        setSelectedTagsIds([]);
        setSelectedPolygon(0);
        setIsPolygonPickerOpen(false);
        setPolygonType(null);
        setSelectedPolygons([]);
        setUserBlockedWorkplacesIds([]);
        setWorkplaces([]);
        setSelectableWorkplaces([]);
        setSelectedWorkplaces([]);
        setUpdateUserModal(false);
        setUpdateUserModalDisplayed(false);
        setTmpActingBodyUnitId(0);
        setDeacApplicationsWarningModal(false);
        setChangeForWarningModal([]);
        setOriginalRoleId(0);
        setWorkScheduleId(0);
        setOriginalWorkScheduleId(0);
        setIsBlocked(false);
        setIsVisitor(false);
        setWasCreatedAsVisitor(false);
        form.reset(defaultEmptyValues);
    }

    async function getUser(id: number) {
        const user = await accessService.getUser(id);
        setIsBlocked(!!user.blockDate);
        setName(user.name);
        setEmail(user.email);
        setRegistry(user.registry);
        setPhone(user.phone);
        setPatent(user.patent || '');
        setWarName(user.warName || '');
        setDocument(user.document || '');
        setProfilePicture(user.facePictureImageUrl ?? '');
        setOriginalWorkScheduleId(user.agentSchedule?.id ?? 0);
        setWorkScheduleId(user.agentSchedule?.id ?? 0);
        setPermissions(user.PermissionLevels);
        setIsVisitor(!!(user.visitorStartDate || user.visitorEndDate));
        setWasCreatedAsVisitor(!!(user.visitorStartDate || user.visitorEndDate));

        form.reset({
            leave: user.leaveOfAbsenceEnd && user.leaveOfAbsenceStart && moment().isBefore(moment(user.leaveOfAbsenceEnd)) ? {
                from: new Date(user.leaveOfAbsenceStart) ?? null,
                to: new Date(user.leaveOfAbsenceEnd) ?? null,
            } : {
                from: null,
                to: null,
            },
            vacation: user.vacationPeriodEnd && user.vacationPeriodStart && moment().isBefore(moment(user.vacationPeriodEnd)) ? {
                from: new Date(user.vacationPeriodStart) ?? null,
                to: new Date(user.vacationPeriodEnd) ?? null
            } : {
                from: null,
                to: null,
            },
            visitorStartDate: user.visitorStartDate ? moment(user.visitorStartDate).toDate() : undefined,
            visitorEndDate: user.visitorEndDate ? moment(user.visitorEndDate).toDate() : undefined,
        });

        if (user.role?.actingBodyId) {
            setActingBodyId(user.role.actingBodyId);
            setRoleId(user.roleId || 0);
            setOriginalRoleId(user.roleId || 0);
            setActingBodyUnitId(user.actingBodyUnitId || 0);

            const [groups, permissionLevels, skills, workplaces] = await Promise.all([
                loadGroups(user.actingBodyUnitId || 0),
                loadPermissionLevels(user.actingBodyUnitId || 0),
                loadSkills(user.role?.actingBodyId || 0),
                loadWorkplaces(user.role?.actingBodyId || 0)
            ]);

            const selectedGroups = user.Groups.map((group) => {
                return {
                    id: group.id || 0,
                    name: group.name
                };
            });
            setSelectedGroups(selectedGroups);
            setUserGroupIds(user.Groups.map((group) => group.id || 0));
            setSelectableGroups((groups?.rows || [])
                .filter((group) => !selectedGroups.find((userGroup) => userGroup.id == group.id))
                .map((group) => {
                    return {
                        id: group.id || 0,
                        name: group.name
                    };
                })
            );

            const selectedPermissionLevels = user.PermissionLevels.map((permissionLevel) => {
                return {
                    id: permissionLevel.id || 0,
                    name: permissionLevel.name
                };
            });
            setSelectedPermissionLevels(selectedPermissionLevels);
            setUserPermissionLevelIds(user.PermissionLevels.map((permissionLevel) => permissionLevel.id || 0));
            setSelectablePermissionLevels((permissionLevels?.rows || [])
                .filter((permissionLevel) => !selectedPermissionLevels.find((userPermissionLevel) => userPermissionLevel.id == permissionLevel.id))
                .map((permissionLevel => {
                    return {
                        id: permissionLevel.id || 0,
                        name: permissionLevel.name
                    };
                }))
            );

            const selectedSkills = user.Skills.map((skill) => {
                return {
                    id: skill.id || 0,
                    name: skill.name
                };
            });
            setSelectedSkills(selectedSkills);
            setUserSkillsIds(user.Skills.map((skill) => skill.id || 0));
            setSelectableSkills((skills?.rows || [])
                .filter((skill) => !selectedSkills.find((userSkill) => userSkill.id == skill.id))
                .map((skill) => {
                    return {
                        id: skill.id || 0,
                        name: skill.name
                    };
                })
            );

            const selectedWorkplaces = user.BlockedWorkplaces.map((workplace) => {
                return {
                    id: workplace.id || 0,
                    name: workplace.name
                };
            });
            setSelectedWorkplaces(selectedWorkplaces);
            setUserBlockedWorkplacesIds(user.BlockedWorkplaces.map((workplace) => workplace.id || 0));
            setSelectableWorkplaces((workplaces?.rows || [])
                .filter((workplace) => !selectedWorkplaces.find((blockedUserWorkplace) => blockedUserWorkplace.id == workplace.id))
                .map((workplace) => {
                    return {
                        id: workplace.id || 0,
                        name: workplace.name
                    };
                })
            );
        }

        if (user.tags.length > 0) {
            setSelectedTagsIds(user.tags.map(tag => tag.id || 0));
        }

    }

    async function loadSkills(actingBodyId: number) {
        try {
            setSelectedSkills([]);
            const skills = await accessService.getSkills({ page: 0, limit: 9999999, actingBodyId });
            setSelectableSkills(skills.rows
                .map((skill) => {
                    return {
                        id: skill.id || 0,
                        name: skill.name
                    };
                }));
            return skills;
        } catch (err) {
            console.error(err);
        }
    }

    async function loadWorkplaces(actingBodyId: number) {
        try {
            setSelectedSkills([]);
            const workplaces = await deacService.getWorkplaces({ page: 0, limit: 9999999, actingBodyId });
            setWorkplaces(workplaces.rows);
            setSelectableWorkplaces(workplaces.rows
                .map((workplace) => {
                    return {
                        id: workplace.id,
                        name: workplace.name
                    };
                }));
            return workplaces;
        } catch (err) {
            console.error(err);
        }
    }

    async function loadGroups(actingBodyUnitId: number) {
        try {
            setSelectedGroups([]);
            const groups = await accessService.getGroups({ page: 0, limit: 9999999, actingBodyUnitIds: [actingBodyUnitId] });
            setSelectableGroups(groups.rows.map((group) => {
                return {
                    id: group.id || 0,
                    name: group.name
                };
            }));
            return groups;
        } catch (err) {
            console.error(err);
        }
    }

    async function loadPermissionLevels(actingBodyUnitId: number) {
        try {
            setSelectedPermissionLevels([]);
            const permissionLevels = await accessService.getPermissionLevels({ page: 0, limit: 9999999, actingBodyUnitIds: [actingBodyUnitId] });
            setSelectablePermissionLevels(permissionLevels.rows.map((permissionLevel) => {
                return {
                    id: permissionLevel.id || 0,
                    name: permissionLevel.name
                };
            }));
            return permissionLevels;
        } catch (err) {
            console.error(err);
        }
    }

    async function loadPageInfo() {
        try {
            const [ownUser] = await Promise.all([
                centralAPI.getOwnUser({ includeRole: true }),
            ]);

            setOwnUser(ownUser);

            if (userId) {
                await getUser(userId);
            } else {
                if (!ownUser.isAdmin && ownUser.actingBodyUnitId && authenticatedUser && !authenticatedUser?.permissions.access_edit_user_all_acting_bodies) {
                    setActingBodyId(ownUser.role?.actingBodyId || 0);
                    loadGroups(ownUser.actingBodyUnitId);
                    loadPermissionLevels(ownUser.actingBodyUnitId);
                    loadSkills(ownUser.role?.actingBodyId || 0);
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    const permissionsMap = useMemo(() => {
        const map: Partial<Record<string, { checked: boolean; sources: string[]; }>> = {};

        permissions?.forEach(permissionLevel => {
            permissionLevel.permissions.forEach((p) => {
                if (!map[p.permission]) {
                    map[p.permission] = {
                        checked: true,
                        sources: []
                    };
                }
                map[p.permission]!.sources.push(permissionLevel.name);
            });
        });

        return map;
    }, [permissions]);

    const isFocused = useIsFocused();
    useFocusEffect(useCallback(() => {
        if (isFocused) {
            loadPageInfo();
        }
    }, [isFocused, navigation, route.params]));

    function isEmpty(value: string) {
        return value == '';
    }

    function isFormValid() {
        if (isEmpty(name) || isEmpty(registry) || isEmpty(email) || isEmpty(phone) || isEmpty(document)) {
            return false;
        }
        if (isEmailInvalid) {
            return false;
        }
        if (!userId && isEmpty(password)) {
            return false;
        }
        if (roleId === 0) {
            return false;
        }
        if (ownUser && ownUser.isAdmin && actingBodyUnitId === 0) {
            return false;
        }
        if (isDocumentInvalid) {
            return false;
        }

        if (!form.formState.isValid && userId) {
            return false;
        }

        return true;
    }

    async function validateFormSubmit() {
        if (userId) {
            let displayWarningModal = false;
            const changes = [];
            const selectedSkillsIds = selectedSkills.map((skill) => Number(skill.id));
            const skillsToRm = userSkillsIds.filter((userSkill) => !selectedSkillsIds.includes(userSkill));
            if (skillsToRm.length > 0) {
                displayWarningModal = true;
                changes.push(translate('skills'));
            }

            if (originalRoleId != roleId) {
                displayWarningModal = true;
                changes.push(translate('role'));
            }

            const selectedWorkplacesIds = selectedWorkplaces.map((workplace) => Number(workplace.id));
            const workplacesToBlock = selectedWorkplacesIds.filter((selectedWorkplace) => !userBlockedWorkplacesIds.includes(selectedWorkplace));

            if (workplacesToBlock.length > 0) {
                displayWarningModal = true;
                changes.push(translate('workplaces'));
            }

            const values = form.getValues();

            if (values.vacation.from && values.vacation.to && form.getFieldState('vacation').isDirty) {
                displayWarningModal = true;
                changes.push(translate('vacationPeriod'));
            }

            if (values.leave.from && values.leave.to && form.getFieldState('leave').isDirty) {
                displayWarningModal = true;
                changes.push(translate('leavePeriod'));
            }

            if ((originalWorkScheduleId != workScheduleId)) {
                displayWarningModal = true;
                changes.push(translate('workSchedule'));
            }

            if (displayWarningModal) {
                setChangeForWarningModal(changes);
                setDeacApplicationsWarningModal(true);
            } else {
                await formSubmit();
            }
        } else {
            await formSubmit();
        }
    }

    async function blobUrlToFile(blobUrl: string, filename: string): Promise<File> {
        const response = await fetch(blobUrl);
        const blob = await response.blob();
        return new File([blob], filename, { type: blob.type });
    }

    async function formSubmit() {
        try {
            if (userId) {
                const formValid = await form.trigger();

                if (!formValid) {
                    Toast.show({
                        type: 'sentinelxError',
                        text1: translate('unexpectedError'),
                    });
                    return;
                }

                const selectedGroupIds = selectedGroups.map((group) => Number(group.id));
                const groupsToAdd = selectedGroupIds.filter((selectedGroup) => !userGroupIds.includes(selectedGroup));
                const groupsToRm = userGroupIds.filter((userGroup) => !selectedGroupIds.includes(userGroup));

                const selectedPermissionLevelIds = selectedPermissionLevels.map((permissionLevel) => Number(permissionLevel.id));
                const permissionLevelsToAdd = selectedPermissionLevelIds.filter((selectedGroup) => !userPermissionLevelIds.includes(selectedGroup));
                const permissionLevelsToRm = userPermissionLevelIds.filter((userGroup) => !selectedPermissionLevelIds.includes(userGroup));

                const selectedSkillsIds = selectedSkills.map((skill) => Number(skill.id));
                const skillsToAdd = selectedSkillsIds.filter((selectedSkill) => !userSkillsIds.includes(selectedSkill));
                const skillsToRm = userSkillsIds.filter((userSkill) => !selectedSkillsIds.includes(userSkill));

                const selectedWorkplacesIds = selectedWorkplaces.map((workplace) => Number(workplace.id));
                const workplacesToBlock = selectedWorkplacesIds.filter((selectedWorkplace) => !userBlockedWorkplacesIds.includes(selectedWorkplace));
                const workplacesToUnblock = userBlockedWorkplacesIds.filter((userBlockedWorkplace) => !selectedWorkplacesIds.includes(userBlockedWorkplace));

                const values = form.getValues();

                await accessService.updateUser(userId, {
                    name,
                    email,
                    document,
                    password,
                    registry,
                    phone,
                    groupsToAdd,
                    permissionLevelsToAdd,
                    skillsToAdd,
                    groupsToRm,
                    permissionLevelsToRm,
                    skillsToRm,
                    roleId,
                    unitId: actingBodyUnitId,
                    patent,
                    warName,
                    actingBodyId,
                    tags: selectedTagsIds,
                    workplacesToBlock,
                    workplacesToUnblock,
                    vacationPeriodStart: values.vacation.from ? values.vacation.from.getTime() : undefined,
                    vacationPeriodEnd: values.vacation.to ? moment(values.vacation.to).endOf('day').valueOf() : undefined,
                    leaveOfAbsenceStart: values.leave.from ? moment(values.leave.from).valueOf() : undefined,
                    leaveOfAbsenceEnd: values.leave.to ? moment(values.leave.to).endOf('day').valueOf() : undefined,
                    agentScheduleId: workScheduleId ? workScheduleId : undefined,
                    visitorStartDate: isVisitor && values.visitorStartDate ? moment(values.visitorStartDate).startOf('day').valueOf() : undefined,
                    visitorEndDate: isVisitor && values.visitorEndDate ? moment(values.visitorEndDate).endOf('day').valueOf() : undefined,
                });

                if (profilePicture && !profilePicture.startsWith('http')) {
                    await centralAPI.updateUserPicture({
                        userId,
                        photo: await blobUrlToFile(profilePicture, 'profilePicture.jpeg'),
                    });
                }

                navigation.navigate('Users', {
                    page: 1,
                    limit: 25,
                });

                Toast.show({
                    type: 'sentinelxSuccess',
                    text1: translate('ActionSuccessfully'),
                });
                return;
            }

            const values = form.getValues();

            const user = await accessService.createUser({
                name,
                email,
                password,
                registry,
                phone,
                document,
                groupsToAdd: selectedGroups.map(item => Number(item.id)),
                permissionLevelsToAdd: selectedPermissionLevels.map(item => Number(item.id)),
                skillsToAdd: selectedSkills.map(item => Number(item.id)),
                workplacesToBlock: selectedWorkplaces.map(item => Number(item.id)),
                roleId,
                unitId: actingBodyUnitId,
                patent,
                warName,
                actingBodyId,
                agentScheduleId: workScheduleId ? workScheduleId : undefined,
                tags: selectedTagsIds,
                visitorStartDate: isVisitor && values.visitorStartDate ? moment(values.visitorStartDate).valueOf() : undefined,
                visitorEndDate: isVisitor && values.visitorEndDate ? moment(values.visitorEndDate).endOf('day').valueOf() : undefined,
            });

            if (user.id && profilePicture) {
                await centralAPI.updateUserPicture({
                    userId: user.id,
                    photo: await blobUrlToFile(profilePicture, 'profilePicture.jpeg'),
                });
            }
            cleanValues();
            navigation.navigate('Users', {
                page: 1,
                limit: 25,
            });

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }

            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    function insidePolygon(point: { lat: number; lng: number; }, polygon: { lat: number; lng: number; }[]): boolean {
        const { lat, lng } = point;
        let inside = false;

        for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            const xi = polygon[i].lng;
            const yi = polygon[i].lat;
            const xj = polygon[j].lng;
            const yj = polygon[j].lat;

            const intersect = ((yi > lat) !== (yj > lat)) &&
                (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi);

            if (intersect) {
                inside = !inside;
            }
        }

        return inside;
    }

    useEffect(() => {
        if (selectedPolygon === 0) {
            return;
        }

        if (!polygonType) {
            setSelectedPolygon(0);
            return setSelectableWorkplaces((workplaces || [])
                .filter((workplace) => !selectedWorkplaces.find((blockedUserWorkplace) => blockedUserWorkplace.id == workplace.id))
                .map((workplace) => {
                    return {
                        id: workplace.id || 0,
                        name: workplace.name
                    };
                })
            );
        }

        const polygon = selectedPolygons.find(p => p.id === selectedPolygon);
        if (polygon) {
            return setSelectableWorkplaces((workplaces || [])
                .filter((workplace) => {
                    return !selectedWorkplaces.find((blockedUserWorkplace) => blockedUserWorkplace.id == workplace.id) &&
                        insidePolygon({
                            lat: workplace.latitude,
                            lng: workplace.longitude,
                        }, polygon.points);
                })
                .map((workplace) => {
                    return {
                        id: workplace.id || 0,
                        name: workplace.name
                    };
                })
            );
        }
    }, [selectedPolygon, polygonType]);

    const handleActingBodiesUnitsChange: React.Dispatch<React.SetStateAction<number>> = (value: React.SetStateAction<number>) => {
        const val = typeof value === 'function' ? value(actingBodyUnitId) : value;
        setTmpActingBodyUnitId(actingBodyUnitId);
        setActingBodyUnitId(val);

        if (val !== actingBodyUnitId && (selectedGroups.length || selectedPermissionLevels.length || selectedSkills.length)) {
            setUpdateUserModal(true);
            setUpdateUserModalDisplayed(true);
        } else {
            loadGroups(val);
            loadPermissionLevels(val);
            loadSkills(val);
        }
    };

    function isVisitorExpired(start: ValuePiece, end: ValuePiece): boolean {
        if (!start && !end) {
            return false;
        }

        const now = moment();
        const startM = start ? moment(start) : null;
        const endM = end ? moment(end).endOf('day') : null;

        if (startM && now.isBefore(startM)) {
            return true;
        }
        if (endM && now.isAfter(endM)) {
            return true;
        }

        return false;
    }

    const watchedVisitorStart = form.watch('visitorStartDate');
    const watchedVisitorEnd = form.watch('visitorEndDate');
    const visitorExpired = isVisitor && isVisitorExpired(watchedVisitorStart, watchedVisitorEnd);

    return (
        <Container>
            <Header
                title={translate('registerUser')}
                actions={<CustomButton
                    text={translate('save')}
                    disabled={!isFormValid()}
                    onPress={() => {
                        if (updateUserModalDisplayed) {
                            formSubmit();
                        } else {
                            validateFormSubmit();
                        }
                    }}
                />}
                goBackAction={() => {
                    cleanValues();
                    navigation.canGoBack() ? navigation.goBack() : navigation.navigate('Users', {
                        page: 1,
                        limit: 25,
                    });
                }}
            />

            <Card>
                <Tabs
                    endContent={userId ? (
                        <View style={{ justifyContent: 'center', alignSelf: 'flex-end' }}>
                            {isBlocked ? (
                                <Badge mode='SQUARE' size='medium' color='red'>
                                    {translate('blocked')}
                                </Badge>
                            ) : visitorExpired ? (
                                <Badge mode='SQUARE' size='medium' color='purple'>
                                    {translate('expiration')}
                                </Badge>
                            ) : (
                                <Badge mode='SQUARE' size='medium' color='green'>
                                    {translate('active')}
                                </Badge>
                            )}
                        </View>
                    ) : undefined} tabs={[{
                        key: 'personal_data',
                        label: translate('personalData')
                    }, {
                        key: 'groups',
                        label: translate('groups'),
                        omit: !(authenticatedUser?.permissions.access_edit_group_settings
                            || authenticatedUser?.permissions.access_edit_group_settings_acting_body_unit
                            || authenticatedUser?.permissions.access_edit_group_settings_all_acting_bodies)
                    }, {
                        key: 'permissionLevels',
                        label: translate('permissionLevels'),
                        omit: !(authenticatedUser?.permissions.access_edit_permission_level_settings
                            || authenticatedUser?.permissions.access_edit_permission_level_settings_acting_body_unit
                            || authenticatedUser?.permissions.access_edit_permission_level_settings_all_acting_bodies)
                    }, {
                        key: 'skills',
                        label: translate('skills')
                    }, {
                        key: 'blockedWorkplaces',
                        label: translate('blockedWorkplaces')
                    }, {
                        key: 'permissions',
                        label: translate('permissions'),
                        omit: !userId
                    }, {
                        key: 'userHistoric',
                        label: translate('userHistoric'),
                    },]}>
                    {({ selectedTab }) => {
                        if (selectedTab == 'personal_data') {
                            return (
                                <ScrollView contentContainerStyle={styles.personalDataContainer}>
                                    <View style={{ flex: 1 }}>
                                        <ProfilePicture photo={profilePicture} setProfilePicture={setProfilePicture} />
                                    </View>
                                    <View style={{ flex: 2, rowGap: 10 }}>
                                        <FormInput
                                            required
                                            label={translate('name')}
                                            placeholder={translate('name')}
                                            value={name}
                                            onChangeText={setName}
                                            invalid={isEmpty}
                                        />
                                        <View style={[windowInfo.isMobile ? { flexDirection: 'column' } : { flexDirection: 'row' }, { gap: 16 }]}>
                                            <MyEmailInput
                                                labelFontSize={16}
                                                label={translate('email')}
                                                value={email}
                                                onChangeText={setEmail}
                                                isInvalid={isEmailInvalid}
                                                setIsInvalid={setIsEmailInvalid}
                                                viewStyle={{ flex: 1 }}
                                                required
                                            />
                                            <MyCpfInput
                                                value={document}
                                                onChangeText={setDocument}
                                                isInvalid={isDocumentInvalid}
                                                setIsInvalid={setIsDocumentInvalid}
                                                viewStyle={{ flex: 1 }}
                                                required
                                            />
                                        </View>
                                        {!userId ?
                                            <FormInput
                                                label={translate('password')}
                                                placeholder={translate('password')}
                                                value={password}
                                                onChangeText={setPassword}
                                                invalid={() => false}
                                                secureTextEntry
                                                required
                                            /> : null
                                        }
                                        <View style={[windowInfo.isMobile ? { flexDirection: 'column' } : { flexDirection: 'row' }, { gap: 16 }]}>
                                            <FormInput
                                                label={translate('registration')}
                                                placeholder={translate('registration')}
                                                value={registry}
                                                onChangeText={setRegistry}
                                                invalid={() => false}
                                                viewStyle={{ flex: 1 }}
                                                required
                                            />
                                            <MyPhoneInput
                                                label={translate('phone')}
                                                placeholder={translate('phone')}
                                                value={phone}
                                                onChangeText={setPhone}
                                                invalid={() => false}
                                                viewStyle={{ flex: 1 }}
                                                labelStyle={{
                                                    fontSize: 16
                                                }}
                                                required
                                            />
                                        </View>
                                        <View style={[windowInfo.isMobile ? { flexDirection: 'column' } : { flexDirection: 'row' }, { gap: 16, zIndex: 14 }]}>
                                            {ownUser?.isAdmin || authenticatedUser?.permissions.access_edit_user_all_acting_bodies ?
                                                <View style={{ flex: 1, zIndex: 12 }}>
                                                    <ActingBodiesDropdown
                                                        value={actingBodyId}
                                                        setValue={(value) => {
                                                            const val = typeof value === 'function' ? value(actingBodyId) : value;
                                                            setActingBodyId(val);
                                                            setRoleId(0);
                                                            setActingBodyUnitId(0);
                                                        }}
                                                        zIndex={1}
                                                        includeAllOption={false}
                                                        required
                                                    />
                                                </View>
                                                : null
                                            }
                                            {ownUser?.isAdmin || authenticatedUser?.permissions.access_edit_user_acting_body_units || authenticatedUser?.permissions.access_edit_user_all_acting_bodies ?
                                                <View style={{ flex: 1, zIndex: 11 }}>
                                                    <ActingBodiesUnitsDropdown
                                                        actingBodyId={actingBodyId}
                                                        value={actingBodyUnitId}
                                                        setValue={handleActingBodiesUnitsChange}
                                                        zIndex={13}
                                                        required
                                                    />
                                                </View>
                                                : <></>
                                            }
                                        </View>
                                        <RolesDropdown
                                            actingBodyId={actingBodyId}
                                            value={roleId}
                                            setValue={setRoleId}
                                            zIndex={13}
                                            required
                                        />

                                        <View style={{ zIndex: 12, flexDirection: 'column' }}>
                                            <WorkScheduleDropdown
                                                label={translate('workSchedule')}
                                                actingBodyId={actingBodyId}
                                                value={workScheduleId}
                                                setValue={setWorkScheduleId}
                                                zIndex={11}
                                            />
                                        </View>

                                        {(!userId || wasCreatedAsVisitor) &&
                                            <View style={{ zIndex: 11 }}>
                                                <FilterCheckBox
                                                    label={translate('visitorUser')}
                                                    value={isVisitor}
                                                    disabled={wasCreatedAsVisitor}
                                                    onChange={() => {
                                                        if (wasCreatedAsVisitor) {
                                                            return;
                                                        }
                                                        const checked = !isVisitor;
                                                        setIsVisitor(checked);
                                                        if (!checked) {
                                                            form.setValue('visitorStartDate', null);
                                                            form.setValue('visitorEndDate', null);
                                                        }
                                                    }}
                                                    zIndex={7}
                                                />
                                            </View>
                                        }

                                        {(!userId || wasCreatedAsVisitor) && isVisitor &&
                                            <View style={[windowInfo.isMobile ? { flexDirection: 'column' } : { flexDirection: 'row' }, { gap: 16, zIndex: Math.max(visitorStartZIndex, visitorFinishZIndex) }]}>
                                                <MyDatePicker
                                                    label={translate('visitorStartDate')}
                                                    form={form}
                                                    dateFieldName='visitorStartDate'
                                                    viewStyle={{ flex: 1, rowGap: 5, zIndex: 10 }}
                                                    zIndex={visitorStartZIndex}
                                                    required
                                                    linkedFields={['visitorEndDate']}
                                                    onCalendarOpen={() => setVisitorStartZIndex(99999)}
                                                    onCalendarClose={() => setVisitorStartZIndex(10)}
                                                />
                                                <MyDatePicker
                                                    label={translate('visitorEndDate')}
                                                    form={form}
                                                    dateFieldName='visitorEndDate'
                                                    viewStyle={{ flex: 1, rowGap: 5, zIndex: 9 }}
                                                    zIndex={visitorFinishZIndex}
                                                    required
                                                    minDate={form.watch('visitorStartDate') ?? undefined}
                                                    customValidations={{
                                                        afterStart: (value, f) => {
                                                            const start = f.getValues('visitorStartDate');
                                                            if (start && value && moment(value).isBefore(start)) {
                                                                return translate('visitorEndDateMustBeAfterStartDate');
                                                            }
                                                            return true;
                                                        }
                                                    }}
                                                    onCalendarOpen={() => setVisitorFinishZIndex(99999)}
                                                    onCalendarClose={() => setVisitorFinishZIndex(9)}
                                                />
                                            </View>
                                        }

                                        <TagsDropdown
                                            value={selectedTagsIds}
                                            setValue={setSelectedTagsIds}
                                            zIndex={8}
                                        />
                                        <FormInput
                                            label={translate('warName')}
                                            placeholder={translate('warName')}
                                            value={warName}
                                            onChangeText={setWarName}
                                            invalid={() => false}
                                        />
                                        <FormInput
                                            label={translate('patent')}
                                            placeholder={translate('patent')}
                                            value={patent}
                                            onChangeText={setPatent}
                                            invalid={() => false}
                                        />

                                        {userId &&
                                            <MyDateRangePicker
                                                label={translate('vacationPeriod')}
                                                form={form}
                                                fieldName='vacation'
                                                zIndex={7}
                                            />
                                        }

                                        {userId &&
                                            <MyDateRangePicker
                                                label={translate('leavePeriod')}
                                                form={form}
                                                fieldName='leave'
                                                zIndex={6}
                                            />
                                        }
                                    </View>
                                </ScrollView>
                            );
                        }
                        if (selectedTab == 'groups') {
                            return <SelectableList
                                selectableLabel={translate('groups')}
                                selectableContent={selectableGroups}
                                selectedLabel={translate('participants')}
                                selectedContent={selectedGroups}
                            />;
                        }

                        if (selectedTab == 'permissionLevels') {
                            return <SelectableList
                                selectableLabel={translate('permissionLevels')}
                                selectableContent={selectablePermissionLevels}
                                selectedLabel={translate('participants')}
                                selectedContent={selectedPermissionLevels}
                            />;
                        }
                        if (selectedTab == 'skills') {
                            return <SelectableList
                                selectableLabel={translate('skills')}
                                selectableContent={selectableSkills}
                                selectedLabel={translate('participants')}
                                selectedContent={selectedSkills}
                            />;
                        }
                        if (selectedTab == 'blockedWorkplaces') {
                            return <View style={{ gap: 8, flex: 1 }}>
                                <View style={{ flexDirection: 'row', gap: 8, zIndex: 2, alignItems: 'center' }}>
                                    <View style={{ flex: 1 }}>
                                        <MapPolygonDropdown
                                            label={translate('subRegions')}
                                            dropDownDirection='BOTTOM'
                                            setPolygons={setSelectedPolygons}
                                            setPolygonType={setPolygonType}
                                            showTooltip
                                            zIndex={3}
                                            labelStyle={styles.selectLabelStyle}
                                            viewStyle={{ gap: 8 }}
                                        />
                                    </View>
                                    {selectedPolygons.length > 0 && <View style={{ flex: 2, zIndex: 2, gap: 8 }}>
                                        <MyAppText>{polygonType}</MyAppText>
                                        <MyDropDownPicker
                                            placeholderColor={theme.colors.placeholder}
                                            placeholder={translate('filter')}
                                            open={isPolygonPickerOpen}
                                            items={selectedPolygons.map(p => {
                                                return { label: p.name, value: p.id };
                                            })}
                                            setOpen={setIsPolygonPickerOpen}
                                            value={selectedPolygon}
                                            setValue={setSelectedPolygon}
                                            multiple={false}
                                            searchable={true}
                                            labelStyle={styles.selectLabelStyle}
                                        />
                                    </View>}
                                </View>
                                <SelectableList
                                    selectableLabel={translate('workplaces')}
                                    selectableContent={selectableWorkplaces}
                                    selectedLabel={translate('blockedWorkplaces')}
                                    selectedContent={selectedWorkplaces}
                                />
                            </View>;
                        }
                        if (selectedTab == 'permissions') {
                            return (
                                <ScrollView contentContainerStyle={styles.permissionsContainer}>
                                    {permissionsValuesStructure.map((permissionsArray, index) => (
                                        <View key={index} style={styles.permissionMainColumn}>
                                            {permissionsArray.map((permission, permissionsIndex) => (
                                                <View key={permissionsIndex} style={styles.permissionColumn}>
                                                    <MyAppText style={styles.permissionSubTitle}>
                                                        {translate(permission.title)}
                                                    </MyAppText>
                                                    {permission.values.map((permissionValue, idx) => {
                                                        const permissionData = permissionsMap[permissionValue.value];

                                                        return (<FilterCheckBox
                                                            key={String(permission)}
                                                            label={translate(permissionValue.label)}
                                                            value={permissionData?.checked ?? false}
                                                            onChange={() => { }}
                                                            showTooltip={permissionData?.checked ?? false}
                                                            tooltipText={`${translate('grantedByLevels')}: ${permissionData?.sources.join(',')}`}
                                                            zIndex={permission.values.length - idx}
                                                            disabled={true}
                                                        />);
                                                    })}
                                                </View>
                                            ))}
                                        </View>
                                    ))}
                                </ScrollView>
                            );
                        }
                        if (selectedTab == 'userHistoric' && userId) {
                            return <UserHistoricList userId={userId} />;
                        }
                    }}
                </Tabs>
            </Card>

            <UpdateActingBodyUnitModal
                setIsModalVisible={setUpdateUserModal}
                isModalVisible={updateUserModal}
                onSubmit={() => {
                    loadGroups(actingBodyUnitId);
                    loadPermissionLevels(actingBodyUnitId);
                    loadSkills(actingBodyUnitId);
                    setUpdateUserModal(false);
                }}
                onClose={() => {
                    setActingBodyUnitId(tmpActingBodyUnitId);
                    setUpdateUserModal(false);
                }} />
            <WarningModal
                isModalVisible={deacApplicationsWarningModal}
                setIsModalVisible={setDeacApplicationsWarningModal}
                text={translate('userGenericDeacChangeWarning')}
                items={changeForWarningModal}
                onSubmit={() => {
                    setDeacApplicationsWarningModal(false);
                    formSubmit();
                }}
                onClose={() => setDeacApplicationsWarningModal(false)}
            />
        </Container>
    );
}

const stylesheet = createStyleSheet(theme => ({
    personalDataContainer: {
        padding: 10,
        flexDirection: {
            xs: 'column',
            md: 'row'
        }
    },
    selectLabelStyle: {
        color: theme.colors.neutral['500'],
        fontWeight: '600',
        fontSize: 14,
    },
    permissionsContainer: {
        rowGap: 20,
        flexDirection: 'row',
        flex: 1,
        flexWrap: 'wrap'
    },
    permissionMainColumn: {
        flex: 1,
        flexDirection: 'column',
        gap: 15,
        minWidth: 200
    },
    permissionColumn: {
        flexDirection: 'column',
        gap: 8,
    },
    permissionSubTitle: {
        color: theme.colors.labelColor,
        fontWeight: 'bold',
        fontSize: 14,
    },
}));
